import { render, staticRenderFns } from "./TableCouponList.vue?vue&type=template&id=a2b212e6&scoped=true"
import script from "./TableCouponList.vue?vue&type=script&lang=js"
export * from "./TableCouponList.vue?vue&type=script&lang=js"
import style0 from "./TableCouponList.vue?vue&type=style&index=0&id=a2b212e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b212e6",
  null
  
)

export default component.exports